import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';
import moment from 'moment';
import helpers from '../../mixins/helpers';

const state = {
    id: 0,
    fechaComprobante: moment(new Date()).format('YYYY-MM-DD'),
    periodo: moment(new Date()).format('YYYY-MM-DD'),
    periodoDia: 1,
    periodoMes: 0,
    periodoMesNombre: null,
    periodoAnio: 0,
    proveedorId: 0,
    proveedor: {},
    proveedorNombre: null,
    impuestoPresentacionAnual: false,
    // comprobanteTipoId: 10,
    // numero: 0,
    total: 0,
    montoNoGravado: 0,
    observaciones: '',
    rowVersion: null,

    comprobanteCancelado: false,

    cuentas: [],
    cuentasInfo: [],
    cuentaSelected: {},
};

const mutations = {
    updateField,

    'INICIALIZAR_COMPRA_IMPUESTO' (state, params) {
        let fecha = moment.utc(new Date()).format('YYYY-MM-DD')

        state.id = params.compraImpuestoId;
        state.fechaComprobante = fecha,
        state.periodo = fecha,
        state.periodoMes= new Date(fecha).getMonth() + 1;
        state.periodoMesNombre= helpers.methods.getMesNombre(state.periodoMes);
        state.periodoAnio= new Date(fecha).getFullYear();
        state.proveedorId= 0;
        state.proveedor= null;
        state.proveedorNombre= null;
        state.impuestoPresentacionAnual = false;
        // state.numero = 0;
        state.total = 0;
        state.montoNoGravado= 0;
        state.observaciones = '';
        state.rowVersion = null;

        state.cuentas = [];
        state.cuentasInfo = [];

        state.comprobanteCancelado = false;
    },
    'SET_COMPRA_IMPUESTO' (state, compraImpuesto) {
        state.fechaComprobante = moment(compraImpuesto.fechaComprobante).format('YYYY-MM-DD'),
        state.periodo = moment(compraImpuesto.periodo).format('YYYY-MM-DD')
        state.periodoMes= new Date(compraImpuesto.periodo).getMonth() + 1;
        state.periodoMesNombre= helpers.methods.getMesNombre(state.periodoMes);
        state.periodoAnio= new Date(compraImpuesto.periodo).getFullYear();
        state.proveedorId = (compraImpuesto.proveedor) ? compraImpuesto.proveedor.id : 0;
        state.proveedor = compraImpuesto.proveedor;
        state.proveedorNombre = (compraImpuesto.proveedor) ? compraImpuesto.proveedor.nombre.trim() : null;
        // state.numero = compra.numero;
        state.total = compraImpuesto.total;
        state.montoNoGravado= compraImpuesto.montoNoGravado;
        state.observaciones = compraImpuesto.observaciones;
        state.rowVersion = compraImpuesto.rowVersion;

        state.cuentas = compraImpuesto.cuentas;
        setCuentasInfo(state);

        state.comprobanteCancelado = ((/true/i).test(compraImpuesto.comprobanteCancelado));
    },
    'SET_PROVEEDOR'(state, proveedor) {
        state.proveedor = proveedor;
        state.proveedorId = proveedor? proveedor.id : 0;
        state.proveedorNombre = proveedor? proveedor.nombre.trim() : null;

        state.impuestoPresentacionAnual = proveedor? proveedor.impuestoPresentacionAnual : false;

        state.cuentas = [];
        if (proveedor) {
            let compraCuenta = {
                cuentaId: proveedor.cuentaId,
                cuenta: proveedor.cuenta,
                rubroId: proveedor.rubroId,
                rubro: proveedor.rubro,
                subrubroId: proveedor.subrubroId,
                subrubro: proveedor.subrubro,
                montoBase: 0,
                montoImpuestos: 0,
            }
            state.cuentas.push(compraCuenta);
        }
        setCuentasInfo(state);
    },
    'SET_CUENTA' (state, compraCuenta) {
        if (state.cuentaSelected != null) {
            state.cuentaSelected.compraCuenta.cuentaId = compraCuenta.cuentaId;
            state.cuentaSelected.compraCuenta.cuenta = compraCuenta.cuenta
            state.cuentaSelected.compraCuenta.rubroId = compraCuenta.rubroId;
            state.cuentaSelected.compraCuenta.rubro = compraCuenta.rubro
            state.cuentaSelected.compraCuenta.subrubroId = compraCuenta.subrubroId;
            state.cuentaSelected.compraCuenta.subrubro = compraCuenta.subrubro
            state.cuentaSelected.compraCuenta.montoBase = compraCuenta.montoBase
            state.cuentaSelected.compraCuenta.montoImpuestos = compraCuenta.montoImpuestos
        } else { 
          state.cuentas.push(compraCuenta);
        }

        setCuentasInfo(state);
    },
    'DELETE_CUENTA' (state) {
        var itemKey = -1
        for (let key in state.cuentas){
            const compraCuenta = state.cuentas[key]
            if ( compraCuenta == state.cuentaSelected.compraCuenta ){
                itemKey = key
            }
        }
        if (itemKey != -1) {
            state.cuentas.splice(itemKey, 1)      
        }
        
        setCuentasInfo(state);
    },
    'ACTUALIZAR_TOTAL' (state) {
        state.montoNoGravado = state.total;

        if (state.cuentas) {
            if (state.cuentas.length == 1) {
                let compraCuenta = state.cuentas[0];
                if (compraCuenta) {
                    compraCuenta.montoBase = state.total;
                }
                setCuentasInfo(state);
            }
        }
    }
};

function setCuentasInfo(state) {
    state.cuentasInfo = []

    state.cuentas.forEach(cuentaInfo => {
        let codigo = (cuentaInfo.cuenta ? cuentaInfo.cuenta.codigo : '')
            + (cuentaInfo.rubro ? cuentaInfo.rubro.codigo : '')
            + (cuentaInfo.subrubro ? cuentaInfo.subrubro.codigo : '');
        let nombre = (cuentaInfo.cuenta ? cuentaInfo.cuenta.nombre : '')
            + (cuentaInfo.rubro ? ' - ' + cuentaInfo.rubro.nombre : '')
            + (cuentaInfo.subrubro ? ' - ' + cuentaInfo.subrubro.nombre : '');

        state.cuentasInfo.push({
            compraCuenta: cuentaInfo,
            codigoCuenta: codigo,
            cuenta: nombre,
            montoBase: cuentaInfo.montoBase,
            montoImpuestos: cuentaInfo.montoImpuestos,
        });
    });
}

const getters = {
    getField,

    getCuentasInfo (state) {
        return state.cuentasInfo;
    },
    getCuentaSelected (state) {
        return state.cuentaSelected;
    },
};

const actions = {
    inicializar ( { commit }, params ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_COMPRA_IMPUESTO', params);

            if (params.compraImpuestoId != 0) {
                /* Recuperamos los datos de la compra */
                apiAxios.get('impuestos/' + params.compraImpuestoId + '/abm' ) 
                    .then(res => {
                        commit('SET_COMPRA_IMPUESTO', res.data);
                        resolve();
                    })
                    .catch(error => reject(helpers.methods.getErrorMessage(error)));
            } else {
                resolve();
            }
            
        })            
    },
    save ( { state } ) {
        return new Promise((resolve, reject) => {
            let save = true;
            let errorMessage = '';
            
            if (parseFloat(state.montoNoGravado) == 0) {
                save = false;
                errorMessage = "El importe total de la declaración jurada no puede ser igual a cero."
            }

            if (save) {
                let periodo;
                if (state.impuestoPresentacionAnual) {
                    periodo = parseInt(state.periodoAnio).toString().trim() + '-01-01';
                } else {
                    periodo = parseInt(state.periodoAnio).toString().trim()
                        + '-' + helpers.methods.getMesNumero(state.periodoMesNombre).toString().trim()
                        + '-01';
                }
                
                let compra= {
                    fechaComprobante: moment(state.fechaComprobante).format('YYYY-MM-DD'),
                    periodo: periodo,
                    proveedorId: parseInt(state.proveedorId),
                    // comprobanteTipoId: parseInt(state.comprobanteTipoId),
                    // numeroPuntoVenta: 1,
                    // numero: parseInt(state.numero),
                    // total: parseFloat(state.total),
                    total: parseFloat(state.montoNoGravado),
                    montoNoGravado: parseFloat(state.montoNoGravado),
                    observaciones: state.observaciones.trim(),

                    cuentas: state.cuentas,
                };

                let url = 'impuestos';
                if (state.id != 0) {
                    url += '/' + state.id;
                    compra.rowVersion = state.rowVersion;
                }

                apiAxios.post(url, compra)
                    .then(() => resolve())
                    .catch(error => reject(helpers.methods.getErrorMessage(error)));
            } else {
                reject(errorMessage);
            }
        })
    },

    setProveedor: ({ commit }, proveedor) => {
        commit('SET_PROVEEDOR', proveedor);
    },
    setCuenta: ({commit}, compraCuenta) => {
        commit('SET_CUENTA', compraCuenta);
    },
    deleteCuenta: ({commit}) => {
        /* Eliminamos la cuenta seleccionada */
        commit('DELETE_CUENTA');
    },
    actualizarTotal: ({commit}) => {
        commit('ACTUALIZAR_TOTAL');
    },
};

function roundNumber(num, scale) {
    if(!("" + num).includes("e")) {
        return +(Math.round(num + "e+" + scale)  + "e-" + scale);
    } else {
        var arr = ("" + num).split("e");
        var sig = ""
        if(+arr[1] + scale > 0) {
        sig = "+";
        }
        return +(Math.round(+arr[0] + "e" + sig + (+arr[1] + scale)) + "e-" + scale);
    }
} 

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}